import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { DoubleButtonsEmailRenderer } from "./email";
import type { DoubleButtonsBlockProps } from "./types";

export function DoubleButtonsEditorRenderer(props: DoubleButtonsBlockProps) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <div className="[&_a]:pointer-events-none [&_a]:cursor-default">
        <DoubleButtonsEmailRenderer isEditor {...props} />
      </div>
    </EmailComponentWrapper>
  );
}
